import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import useStyles from './Snackbar.styles';

export const SnackbarComponent = ({
  action,
  className,
  dataQa,
  error,
  long,
  message,
  show,
  zIndex
}) => {
  const { errorStyle, longStyle, snack } = useStyles();
  if (!show) return null;
  return (
    <div
      className={classnames(className, snack, { [errorStyle]: error })}
      data-qa={dataQa}
      style={zIndex && { zIndex }}
    >
      <p>{message}</p>
      {action && <div className={classnames({ [longStyle]: long })}>{action}</div>}
    </div>
  );
};

SnackbarComponent.propTypes = {
  className: PropTypes.string,
  dataQa: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  error: PropTypes.bool,
  action: PropTypes.node,
  long: PropTypes.bool,
  zIndex: PropTypes.number
};

SnackbarComponent.defaultProps = {
  className: '',
  error: false,
  action: null,
  long: false,
  zIndex: null
};

export default SnackbarComponent;
